export const Login="authlogin"

export const Logout="authlogout"

export const Register="register"